import {
	KontentCurriculumCommonResultData,
	TaxoStageWithLifeSkill,
} from '@/types'
import { TaxoKeyLearningArea } from '@/kontent/taxonomies'
import { useMemo } from 'react'

export function useDisabledStages(
	_config: KontentCurriculumCommonResultData<any>['config'],
) {
	// CMS fields marked for deletion (renamed to del_*) - returning empty array pending cleanup
	// const disabledStages = useMemo(() => {
	// 	return config?.item?.elements?.disabled_stages?.value.map(
	// 		(item) => item.name,
	// 	)
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, [JSON.stringify(config?.item?.elements?.disabled_stages?.value)])

	return [] as string[]
}
export function useDisabledTaxoStages(
	_config: KontentCurriculumCommonResultData<any>['config'],
) {
	// CMS fields marked for deletion (renamed to del_*) - returning empty array pending cleanup
	// const disabledStages = useMemo(() => {
	// 	return getTaxoCodenames(config?.item?.elements?.disabled_stages)
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, [JSON.stringify(config?.item?.elements?.disabled_stages?.value)])

	return [] as TaxoStageWithLifeSkill[]
}

export function useDisabledTaxoLearningAreas(
	_config: KontentCurriculumCommonResultData<any>['config'],
) {
	// CMS fields marked for deletion (renamed to del_*) - returning empty array pending cleanup
	// const disabledLearningAreas = useMemo(() => {
	// 	return getTaxoCodenames(
	// 		config?.item?.elements?.disabled_key_learning_areas,
	// 	)
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, [
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// 	JSON.stringify(
	// 		config?.item?.elements?.disabled_key_learning_areas?.value,
	// 	),
	// ])
	return [] as TaxoKeyLearningArea[]
}

export default function useDisabledLearningAreasAndStages(
	config: KontentCurriculumCommonResultData<any>['config'],
	selectedTabView?: string,
) {
	const disabledStages = useDisabledTaxoStages(config)
	const disabledLearningAreas = useDisabledTaxoLearningAreas(config)

	// Tab-aware disabled states - reset to empty arrays when tab changes
	// This allows each tab to start fresh without disabled restrictions from CMS
	const tabAwareDisabledStages = useMemo(() => {
		// When switching tabs, provide fresh start by resetting disabled states
		// Different tabs may have different requirements:
		// - download_syllabus: May need CMS restrictions
		// - custom_view: May need different restrictions
		// - resources: May need no restrictions initially

		switch (selectedTabView) {
			case 'download_syllabus':
				// Use CMS configuration for download tab
				return disabledStages || []
			case 'custom_view':
				// Reset disabled stages when switching to custom view to provide fresh start
				return []
			case 'resources':
				// Reset disabled stages when switching to resources to provide fresh start
				return []
			default:
				// Default to CMS configuration
				return disabledStages || []
		}
	}, [disabledStages, selectedTabView])

	const tabAwareDisabledLearningAreas = useMemo(() => {
		// When switching tabs, provide fresh start by resetting disabled states
		// Different tabs may have different requirements for learning areas

		switch (selectedTabView) {
			case 'download_syllabus':
				// Use CMS configuration for download tab
				return disabledLearningAreas || []
			case 'custom_view':
				// Reset disabled learning areas when switching to custom view to provide fresh start
				return []
			case 'resources':
				// Reset disabled learning areas when switching to resources to provide fresh start
				return []
			default:
				// Default to CMS configuration
				return disabledLearningAreas || []
		}
	}, [disabledLearningAreas, selectedTabView])

	return {
		disabledStages: tabAwareDisabledStages,
		disabledLearningAreas: tabAwareDisabledLearningAreas,
	}
}
